//component
import { useNavigate, useSearchParams } from "react-router-dom";
import CommonTitle from "../../components/common/common.title";
import OrderList from "./components/order.list";
import { useDispatch, useSelector } from "react-redux";
import Pusher from "pusher-js";
import { useEffect } from "react";
import { closeFullLoading } from "../../redux/reducer/common.reducer";
import { getOrderList } from "../../redux/reducer/order.reducer";
import CommonNotFound from "../../components/common/common.not.found";
import { showToast } from "../../helpers/show.toast";
import { handleCatchError } from "../../helpers/handle.catch.error";

export default function Order() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orderList, orderListLoading } = useSelector((state) => state.order);
  const { token, userId, username } = useSelector((state) => state.common);

  const [searchParams, setSearchParams] = useSearchParams();

  const id = searchParams.get("order_id");
  const status = searchParams.get("status");

  //call order paid socket
  useEffect(() => {
    if (token && userId && username) {
      const pusher = new Pusher(process.env.REACT_APP_SOCKET_API_KEY, {
        cluster: "ap1",
        authEndpoint: process.env.REACT_APP_SOCKET_API_URL,
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            username: username === "null" ? null : username,
          },
        },
      });

      const channel = pusher.subscribe("presence-user" + userId);

      let socketId = null;
      pusher.connection.bind("connected", () => {
        socketId = pusher.connection.socket_id;
      });

      channel.bind("order-paid-event", (data) => {
        if (data) {
          dispatch(closeFullLoading());

          if (data.data.payment_status && data.data.order_id) {
            if (
              data.data.payment_status !== null &&
              data.data.order_id !== null
            ) {
              dispatch(getOrderList());
              navigate(
                `?status=${data.data.payment_status}&order_id=${data.data.order_id}`,
                { replace: true }
              );
            }
          }
        }
      });

      return () => {
        channel.unbind("order-paid-event");
        pusher.disconnect();
      };
    }
  }, [token, userId, username]);

  useEffect(() => {
    if (token && username) {
      dispatch(getOrderList())
        .unwrap()
        .then((res) => {
          if (id && status) {
            if (status === "completed") {
              showToast(
                "Order created!",
                "Thank you for your purchase! Your payment was successful, and your order has been placed.",
                "success"
              );
            } else if (status === "failed") {
              showToast(
                "Payment Failed!",
                "The order has been created, but the payment was not processed. Please complete the payment to confirm your order.",
                "error"
              );
            }
          }
        })
        .catch((ex) => handleCatchError(ex, null));
    }
  }, [token, username]);

  return (
    <article className="order">
      {orderListLoading || orderList?.length > 0 ? (
        <>
          <CommonTitle title="Orders" subtitle="Track Your" />
          <OrderList />
        </>
      ) : (
        <CommonNotFound
          title="No Orders Found"
          message="You haven't placed any orders yet. Explore our products and shop today!"
        />
      )}
    </article>
  );
}
